import * as React from 'react';
import { compose } from 'redux';

// HOC
import {
  withInjectReducer,
  WithInjectReducerProps,
} from '@shopee-user/platform';
import { connect, ConnectedProps } from 'react-redux';

// Redux
import {
  fetchLoginStatus,
  REDUCER_NAME,
  reducer,
  getLoginStatus,
  getLoginStatusAPIProgress,
  State,
} from '@shopee-user/account-redux';

const mapStateToProps = (state: State) => {
  return {
    loginStatus: getLoginStatus(state),
    loginStatusAPIProgress: getLoginStatusAPIProgress(state),
  };
};

const actionCreators = {
  fetchLoginStatus,
};

const connector = connect(mapStateToProps, actionCreators);

export type WithLoginStatusProps = ConnectedProps<typeof connector> &
  WithInjectReducerProps;

export function withLoginStatus<P>() {
  return function (
    WrappedComponent: React.ComponentType<P & WithLoginStatusProps>
  ): React.ComponentType<P> {
    function ComponentWithAccountInfo(
      props: P & WithLoginStatusProps
    ): JSX.Element {
      const { injectAsyncReducer, fetchLoginStatus } = props;
      React.useEffect(() => {
        injectAsyncReducer({ [REDUCER_NAME]: reducer });
        void fetchLoginStatus({});
      }, [fetchLoginStatus, injectAsyncReducer]);

      return <WrappedComponent {...props} />;
    }

    return compose(
      connector,
      withInjectReducer
    )(ComponentWithAccountInfo) as React.ComponentType<P>;
  };
}
